import { Form } from 'antd'
import Context from 'context/appContext'
import { useContext } from 'react'

// @styles
import './styles.scss'

export default function SpaceField() {
    const { checked } = useContext(Context)
    return (<Form.Item className='hidden-fake-field' />)
}